import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

import { provideModuleInfo } from '@mp/shared/util';
import { ADDRESS_EDIT_TAB_PLUGIN } from '@mpomd/shared/util';

import { createAddressCostCentersTabPlugin } from '../plugins';

const moduleName = 'AddressCostCenters';

export function provideAddressCostCentersFeature(): EnvironmentProviders[] {
  return [
    provideModuleInfo(moduleName, {
      displayName: 'Kostenstellen',
    }),
    makeEnvironmentProviders([
      { provide: ADDRESS_EDIT_TAB_PLUGIN, multi: true, useFactory: createAddressCostCentersTabPlugin },
    ]),
  ];
}
